export const SECTION_CONTAINER =
  "mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8";

export const CONTENT_WIDTH =
  "mx-auto w-full max-w-6xl px-4 sm:w-[92%] md:w-[85%]";

export const INTRO_WIDTH =
  "mx-auto w-full max-w-4xl px-4 sm:w-[90%] md:w-[80%]";
